import { useState } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ShareIcon from '@mui/icons-material/Share';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon
} from 'react-share';

import classes from './Share.module.css';

const Share = props => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const convertMSMonth = milliseconds => {
    let date = new Date(milliseconds);
    const month = date.getMonth();
    return month;
  };

  const convertMSYear = milliseconds => {
    let date = new Date(milliseconds);
    const year = date.getFullYear();
    return year;
  };

  const openLinkedin = () => () => {
    setAnchorEl(null);
    const endDateMonth = convertMSMonth(props.endDate);
    const endDateYear = convertMSYear(props.endDate);
    window.open(
      `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${
        props.courseDegree
      }&organizationId=3114094&issueYear=${endDateYear}&issueMonth=${
        endDateMonth + 1
      }&certUrl=${props.urlDegree}`,
      '_blank'
    );
  };

  const handlerCopyDegree = () => {
    setAnchorEl(null);
    const copyText = document.getElementById('urlDegreeCopy');
    navigator.clipboard
      .writeText(copyText.value)
      .then(() => {
        console.log('Texto copiado al portapapeles');
      })
      .catch(err => {
        console.error('Error al copiar al portapapeles:', err);
      });
  };

  const twitterHashtags = ['Mayahii'];

  return (
    <>
      <IconButton onClick={handleClick} className={classes.moreBtn}>
        <ShareIcon />
      </IconButton>
      <Menu
        classes={{ paper: classes.menuContainer }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem className={classes.menuItem}>
          <TwitterShareButton
            title={`Completé el curso ${props.courseDegree} en @MayahiiEdu. Ve mi diploma`}
            hashtags={twitterHashtags}
            url={props.urlDegree}
            className="Demo__some-network__share-button"
          >
            <XIcon size={40} bgStyle={{ fill: '#464872' }} />{' '}
            <span className={classes.textShare}>X</span>
          </TwitterShareButton>
        </MenuItem>
        <MenuItem
          onClick={openLinkedin(props.urlDegree)}
          className={classes.menuItem}
        >
          <LinkedinShareButton>
            <LinkedinIcon size={40} bgStyle={{ fill: '#464872' }} />{' '}
            <span className={classes.textShare}>Linkedin</span>
          </LinkedinShareButton>
        </MenuItem>
        <MenuItem className={classes.menuItem}>
          <FacebookShareButton
            quote={`Completé el curso ${props.courseDegree} en #Mayahii`}
            hashtag="Mayahii"
            url={props.urlDegree}
            className="Demo__some-network__share-button"
          >
            <FacebookIcon size={40} bgStyle={{ fill: '#464872' }} />{' '}
            <span className={classes.textShare}>Facebook</span>
          </FacebookShareButton>
        </MenuItem>
        <MenuItem
          onClick={handlerCopyDegree}
          className={classes.menuItem}
        >
          <FacebookShareButton>
            <FileCopyIcon
              style={{
                width: 40,
                marginLeft: 3,
                color: '#FFFFFF'
              }}
            />{' '}
            <span className={classes.textShareLink}>
              Liga pública
            </span>
          </FacebookShareButton>
        </MenuItem>
        <input
          type="text"
          id="urlDegreeCopy"
          value={props.urlDegree}
          className={classes.inputCode}
        />
      </Menu>
    </>
  );
};

Share.propTypes = {
  // eslint-disable-next-line react/require-default-props
  urlDegree: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  courseDegree: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  endDate: PropTypes.number
};

export default Share;
